var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "url(#paint0_linear_275_400)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43784 19.7633C15.0738 17.231 18.8258 15.5484 20.7098 14.7321C26.0721 12.4165 27.1992 12.0167 27.9239 12C28.0849 12 28.4392 12.0333 28.6807 12.2332C28.8739 12.3998 28.9222 12.6164 28.9545 12.783C28.9867 12.9496 29.0189 13.2994 28.9867 13.566C28.6968 16.7313 27.4408 24.4112 26.7967 27.943C26.5229 29.4423 25.9915 29.9421 25.4762 29.9921C24.349 30.092 23.4956 29.2258 22.4167 28.4927C20.7098 27.3433 19.7597 26.6269 18.1012 25.4941C16.1849 24.1946 17.4248 23.4783 18.5198 22.3121C18.8097 22.0123 23.7532 17.3476 23.8499 16.9312C23.866 16.8812 23.866 16.6813 23.7532 16.5813C23.6405 16.4814 23.4795 16.5147 23.3507 16.548C23.1735 16.5813 20.4683 18.4472 15.2027 22.1289C14.4297 22.6786 13.7373 22.9452 13.1093 22.9285C12.4169 22.9119 11.0964 22.5287 10.0981 22.1955C8.89035 21.7957 7.92418 21.5791 8.00469 20.8794C8.053 20.5129 8.53608 20.1464 9.43784 19.7633Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_275_400",
    x1: 19.9833,
    y1: 0,
    x2: 19.9833,
    y2: 39.6836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramMini);
export default __webpack_public_path__ + "static/media/telegram-mini.32b75479faa6b715915db6dd4c278bb8.svg";
export { ForwardRef as ReactComponent };